import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Label = ({ label, icon, className }: { label: string; icon?: IconDefinition; className?: string }) => {
    return (
        <div className={['flex flex-row items-center flex-nowrap gap-1 text-xs uppercase tracking-wide', className].filter(Boolean).join(' ')}>
            {icon && <FontAwesomeIcon icon={icon} className='w-4' />}
            <div>{label}</div>
        </div>
    )
}
